export default "__VITE_ASSET__C$yZGMAc__"